import $ from 'jquery';

//Add our custom fullscreen control
export function addFullscreenControl() {
  $('#map .mapboxgl-ctrl-top-right .mapboxgl-ctrl-group').append(
    '<button class="mapboxgl-ctrl-icon mapboxgl-ctrl-expand" type="button"><span class="glyphicon glyphicon-resize-full"></span></button>'
  );
}

//Add style selection buttons
export function addStyleSelectionButtons() {
  $('#map .mapboxgl-ctrl-top-left').append(
    '<div class="mapboxgl-ctrl-group mapboxgl-ctrl"><button style="width:80px;" class="mapboxgl-ctrl-style mapboxgl-ctrl-style-street mapboxgl-ctrl-style-active" type="button">Street Map</button><button style="width:80px;" class="mapboxgl-ctrl-style mapboxgl-ctrl-style-satellite" type="button">Satellite</button></div>'
  );
}

//Add legend
export function addLegend() {
    $('#map .mapboxgl-ctrl-bottom-left').append(
        '<div class="mapboxgl-ctrl-group mapboxgl-ctrl"><div class="en-legend" style="padding: 3px;"><div class="en-legend-title">Legend</div><div class="en-legend-item">Auction<img src="/images/auction_marker.svg" alt="Auction Lot"></div><div class="en-legend-item">Sealed Bid<img src="/images/sealed_marker.svg" alt="Sealed Bid Lot"></div><div class="en-legend-item">Govt.<img src="/images/govt_marker.svg" alt="Government Lot"></div></div></div>'
  );
}

export function addSatelliteView(prefs) {
  if (prefs.mapSatelliteView) {
    $('.mapboxgl-ctrl-style-street').removeClass('mapboxgl-ctrl-style-active');
    $('.mapboxgl-ctrl-style-satellite').addClass('mapboxgl-ctrl-style-active');
  }
}

// Ensures bbox corners are in order as W, S, N, E, swap from E, N, W, S as necessary
export function fixBounds(bbox) {
  bbox.map(function (i) {
    if (typeof i == 'string') {
      i = parseFloat(i);
    }
    return i;
  }); //Numify
  if (bbox[2] < bbox[0]) {
    bbox[2] = [bbox[0], (bbox[0] = bbox[2])][0];
  } //swap 0 and 2
  if (bbox[3] < bbox[1]) {
    bbox[3] = [bbox[1], (bbox[1] = bbox[3])][0];
  } //swap 1 and 3
  return bbox;
}

export function setPrefs(storageKey, prefs) {
  prefs = localStorage.getItem(storageKey);
  if (prefs) {
    prefs = JSON.parse(prefs);
  } else {
    prefs = {};
  }

  // See if we are on the current version of prefs and if not reset them
  let prefs_version = '2016110102';
  if (!('version' in prefs) || prefs.version != prefs_version) {
    //Reset prefs
    prefs = { showMap: true, version: prefs_version };
  }
  if (typeof prefs.mapSatelliteView == 'undefined') {
    prefs.mapSatelliteView = false;
  }

  localStorage.setItem(storageKey, JSON.stringify(prefs));

  return prefs;
}

export function handleSatelliteView(prefs, prefsKey, map, styleStreet, styleSatellite) {
  $('.mapboxgl-ctrl-style').on('click', function () {
    const $this = $(this);
    if (!$this.hasClass('mapboxgl-ctrl-style-active')) {
      if ($this.hasClass('mapboxgl-ctrl-style-street')) {
        $('.mapboxgl-ctrl-style').toggleClass('mapboxgl-ctrl-style-active');
        map.setStyle(styleStreet);
        prefs.mapSatelliteView = false;
        localStorage.setItem(prefsKey, JSON.stringify(prefs));
      }

      if ($this.hasClass('mapboxgl-ctrl-style-satellite')) {
        $('.mapboxgl-ctrl-style').toggleClass('mapboxgl-ctrl-style-active');
        map.setStyle(styleSatellite);
        prefs.mapSatelliteView = true;
        localStorage.setItem(prefsKey, JSON.stringify(prefs));
      }
    }
  });
}

export function handleFullscreenControl(map) {
  $('.mapboxgl-ctrl-expand').on('click', function () {
    const $body = $('body');
    const $icon = $('.mapboxgl-ctrl-expand .glyphicon');

    if ($body.hasClass('map-expanded')) {
      $icon
        .removeClass('glyphicon-resize-small')
        .addClass('glyphicon-resize-full');
      map.scrollZoom.disable();
    } else {
      $icon
        .removeClass('glyphicon-resize-full')
        .addClass('glyphicon-resize-small');
      map.scrollZoom.enable();
    }

    $body.toggleClass('map-expanded');
    map.resize();
  });
}

export function prepareSourceStyles(map){
  let sources;
  let styles;

  (function () {
    var mapStyle = map.getStyle();
    sources = mapStyle.sources;
    styles = mapStyle.layers;
    //TODO wo only need to save our own styles not the styles of the whole map
  })();

  //Event handler to restore our client-side sources and styles on style change
  map.on('style.load', function () {
    //restore map sources
    for (const source in sources) {
      if (source.indexOf('en_') !== -1) {
        map.addSource(source, sources[source]);
      }
    }
    //restore map styles
    for (let i = 0; i < styles.length; i++) {
      if (styles[i].id.indexOf('en_') !== -1) {
        map.addLayer(styles[i]);
      }
    }
  });

}